<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">情報分析 / 活動任務分析</b-col>
      <b-col>
        <div class="text-right">
          <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
        </div>
      </b-col>
    </b-row>
    <div id="func-content">
      <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row">
                  <label class="control-label col-md-2 mt-2">活動效期區間：</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="sdate">
                  </div>
                  <label class="mt-2">至</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="edate">
                  </div>
                  <div class="col-md-3">
                    <button type="button" class="btn btn-warning text-white" @click="getinformationaction(0, 1)">查詢</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-collapse>
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <fieldset>
              <legend>固定活動</legend>
              <table id="mytable" class="table table-bordred table-striped">
                <thead>
                  <tr>
                    <th>項次</th>
                    <th>活動任務</th>
                    <th>送出總點數</th>
                    <th>因推薦而成功加入會員的人數</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(x,index) in alwaysAct" :key="index">
                    <td>{{index+1}}</td>
                    <td>
                      <span v-if="x.Name === 'A5'">生日禮活動</span>
                      <span v-if="x.Name === 'A1'">升級正式會員活動</span>
                      <span v-if="x.Name === 'A3'">推薦好友活動</span>
                    </td>
                    <td>{{x.Bonus}}</td>
                    <td>{{x.Name === 'A3' ? x.Count : '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </fieldset>
          </div>
        </div>
      </b-card>
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <fieldset>
              <legend>限時活動</legend>
              <table id="mytable2" class="table table-bordred table-striped">
                <thead>
                  <tr>
                    <th>項次</th>
                    <th>活動任務</th>
                    <th>活動開始日期</th>
                    <th>活動結束日期</th>
                    <th>送出總點數</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(x,index) in timelimAct" :key="x.index">
                    <td>{{((currentPage-1)*perpage+index+1)}}</td>
                    <td style="width:50%">{{x.name}}</td>
                    <td>{{x.enabledAt|YYYYMMDD}}</td>
                    <td>{{x.disabledAt|YYYYMMDD}}</td>
                    <td>{{x.bonus}}</td>
                  </tr>
                </tbody>
              </table>
              <div>
                <div class="row" style="padding: 0 1rem">
                  <b-pagination size="md" :total-rows="totalrows" v-model="currentPage" :per-page="perpage" @change="getinformationaction(1, $event)"></b-pagination>
                  <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{totalrows}}筆</label>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </b-card>
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <fieldset>
              <legend>線上點餐限時活動</legend>
              <table id="mytable3" class="table table-bordred table-striped">
                <thead>
                  <tr>
                    <th>項次</th>
                    <th>活動任務</th>
                    <th>活動開始日期</th>
                    <th>活動結束日期</th>
                    <th>送出總點數</th>
                    <!-- <th>總折扣金額</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(x,index) in ordAct" :key="x.index">
                    <td>{{((ordCurrentPage-1)*perpage+index+1)}}</td>
                    <td style="width:50%">{{x.name}}</td>
                    <td>{{x.enabledAt|YYYYMMDD}}</td>
                    <td>{{x.disabledAt|YYYYMMDD}}</td>
                    <td>{{x.bonus}}</td>
                    <!-- <td>{{x.discount}}</td> -->
                  </tr>
                </tbody>
              </table>
              <div>
                <div class="row" style="padding: 0 1rem">
                  <b-pagination size="md" :total-rows="ordTotalrows" v-model="ordCurrentPage" :per-page="perpage" @change="getinformationaction(2, $event)"></b-pagination>
                  <label style="margin:8px">{{ordStartRowNum}}到{{ordEndRowNum}}，總共 {{ordTotalrows}}筆</label>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import miniToastr from 'mini-toastr'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
export default {
  data () {
    return {
      sdate: '',
      edate: '',
      currentPage: 1,
      perpage: 20,
      totalrows: 0,
      startRowNum: 0,
      endRowNum: 0,
      alwaysAct: [],
      timelimAct: [],
      ordCurrentPage: 1,
      ordTotalrows: 0,
      ordStartRowNum: 0,
      ordEndRowNum: 0,
      ordAct: []
    }
  },
  created () {
    this.setdate()
    this.getinformationaction(0, 1)
    this.FunctionPermission = getFunctionPermission('F14') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }
  },
  methods: {
    getinformationaction (searchType, currentPage) {
      var edate = '9999-12-31'
      if (this.edate !== '') {
        edate = this.edate
      }
      if (this.sdate > edate) {
        miniToastr.success('請選擇正確的效期區間')
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/information/action/v1', {
        sdate: this.sdate,
        edate: edate,
        toPage: currentPage,
        perPage: this.perpage
      })
        .then((response) => {
          if (response.data.result === '0000') {
            if (searchType === 0) {
              if (response.data.fixedaction != null) {
                this.alwaysAct = response.data.fixedaction
              }
              var A1 = true
              var A3 = true
              var A5 = true
              if (this.alwaysAct != null) {
                this.alwaysAct.forEach(function (item, index, array) {
                  if (item.Name === 'A1') {
                    A1 = false
                  }
                  if (item.Name === 'A3') {
                    A3 = false
                  }
                  if (item.Name === 'A5') {
                    A5 = false
                  }
                })
              }
              if (A1) {
                this.alwaysAct.push({Name: 'A1', Bonus: 0})
              }
              if (A3) {
                this.alwaysAct.push({Name: 'A3', Bonus: 0})
              }
              if (A5) {
                this.alwaysAct.push({Name: 'A5', Bonus: 0})
              }
            }
            if (searchType !== 2) {
              this.timelimAct = response.data.data.byStore.actionList
              this.totalrows = (response.data.data.byStore.count === undefined) ? 0 : response.data.data.byStore.count
              this.currentPage = currentPage
              this.startRowNum = (response.data.data.byStore.count === undefined || response.data.data.byStore.count === 0) ? 0 : this.perpage * (this.currentPage - 1) + 1
              this.endRowNum = (response.data.data.byStore.count === undefined || response.data.data.byStore.count === 0) ? 0 : (this.perpage > response.data.data.byStore.count) ? response.data.data.byStore.count : (this.currentPage * this.perpage) >= response.data.data.byStore.count ? response.data.data.byStore.count : this.currentPage * this.perpage
            }
            if (searchType !== 1) {
              this.ordAct = response.data.data.byOrder.actionList
              this.ordTotalrows = (response.data.data.byOrder.count === undefined) ? 0 : response.data.data.byOrder.count
              this.ordCurrentPage = currentPage
              this.ordStartRowNum = (response.data.data.byOrder.count === undefined || response.data.data.byOrder.count === 0) ? 0 : this.perpage * (this.ordCurrentPage - 1) + 1
              this.ordEndRowNum = (response.data.data.byOrder.count === undefined || response.data.data.byOrder.count === 0) ? 0 : (this.perpage > response.data.data.byOrder.count) ? response.data.data.byOrder.count : (this.ordCurrentPage * this.perpage) >= response.data.data.byOrder.count ? response.data.data.byOrder.count : this.ordCurrentPage * this.perpage
            }
            // this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '查詢失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error.message, '查詢失敗')
          this.$parent.Loading = false
        })
    },
    setdate () {
      var date = new Date()
      date.setMonth(date.getMonth() - 3)
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate()

      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      this.sdate = year + '-' + mon + '-' + day
      this.edate = ''
    }
  },
  filters: {
    formatDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours()
      var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes()
      var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
      return year + '/' + month + '/' + day + ' ' + hour + ':' + minutes + ':' + seconds
    },
    YYYYMMDD: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      if (month < 10) {
        month = '0' + month
      }
      return year + '/' + month + '/' + day
    }
  }
}
</script>
<style scoped>
  fieldset {
    padding: 8px 22px 18px;
    margin: 3px 12px 18px;
    border: 1px solid #519b39;
  }
  legend {
    padding: .2em;
    border: 0;
    width: auto;
    color: #519b39;
  }
  .box-shadow {
    box-shadow: 0px 0px 1px 1px #cfcfcf;
  }
</style>



// WEBPACK FOOTER //
// src/pages/information/activity/List.vue